// extracted by mini-css-extract-plugin
export default {"simpleBehavior":"simple-behavior__rrUj94_r","measurement":"measurement__UjwRhzoj"};